<template>
    <Wrapper :title="$t('revoke.accountRevoke')" :showBack="false">
        <template #content>
            <h2 class="text-base mb-24">{{$t('revoke.condition')}}</h2>
            <p>{{$t('common.hello')}}</p>
            <br />
            <p class="indent-2">{{$t('revoke.conditionDetail0')}}</p>
             <br />
            <p>
                <ol>
                    <li class="indent-2">{{ $t('revoke.conditionDetail1') }}</li>
                    <li class="indent-2">{{ $t('revoke.conditionDetail2') }}</li>
                    <li class="indent-2">{{ $t('revoke.conditionDetail3') }}</li>
                    <li class="indent-2">{{ $t('revoke.conditionDetail4') }}</li>
                </ol>
            </p>
        </template>
        <template #footer>
            <div class="agreed flex text-xs text-left mb-12">
                <van-checkbox v-model="agreed" shape="square" icon-size="12" />
                {{ $t('revoke.conditionAgreed') }}
            </div>
            <van-button type="info" class="w-full" :disabled="disabled" @click="handleClick">
                {{ $t('common.nextStep') }}
            </van-button>
        </template>
    </Wrapper>
</template>

<script>
import Vue from 'vue';
import { Button, Checkbox, Dialog } from 'vant';
import isString from 'lodash/isString';
import Wrapper from './Wrapper.vue';
import { Target } from '../constant';

Vue.use(Button);
Vue.use(Checkbox);

export default {
    name: 'RevokeCondition',
    components: {
        Wrapper,
    },
    props: {
        sdk2WebTicket: {
            type: String,
            default: null,
        }
    },
    data() {
        return {
            agreed: false,
        };
    },
    computed: {
        disabled() {
            const { platform } = this.$route.query;
            return [1, 2].includes(Number(platform)) ? false : (!this.sdk2WebTicket || (isString(this.sdk2WebTicket) && this.sdk2WebTicket.indexOf('errorId') !== -1));
        }
    },
    methods: {
        handleClick() {
            if (!this.agreed) {
                return Dialog.alert({
                    title: this.$t('common.tip'),
                    message: this.$t('revoke.confirmTip'),
                    confirmButtonText: this.$t('common.confirm'),
                    confirmButtonColor: 'var(--g-text-link-color)',
                    getContainer: '#index',
                });
            }

            this.$emit('on-step', { current: Target.RevokeCondition, target: Target.RevokeProtocol });
        },
    },
};
</script>

<style lang="scss" scoped>
.agreed {
    color: var(--g-gray-4);

    .van-checkbox {
        width: 15px;
        margin-right: 5px;
    }
}
</style>
